import { graphql } from "gql";

const HAPPYCO_PROPERTIES_QUERY = graphql(`
  query HappycoProperties {
    happycoProperties {
      ...HappycoProperty
    }
  }
`);

export default HAPPYCO_PROPERTIES_QUERY;
